import React, { useState, useEffect } from "react";
import {

  Typography,
  Button,
  Grid,
  Box,
  CircularProgress,
} from "@mui/material";
import Textfield from "../shared/textfield";
import AccessLocalStorage from "../../services/localStorage";
import {getApiUrl} from "../../services/api_service";
import { dashboardText, mainGrid, paddingbox, rcolor, whitecolor } from "../../style2";


function MainDetails() {
  const [edit, setEdit] = React.useState(false);

  const handleEdit = () => {
    if (edit) {
      onSubmit();
    } else {
      setEdit(true);
      setSuccess("");
    }
  };
  //const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState(null);
  const [professional, setProfessional] = useState(null);
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [registrationNo, setRegistrationNo] = useState("");
  const [profession, setProfession] = useState("");
  const [hospitalName, setHospitalName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const ls = new AccessLocalStorage();

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    setLoading(true);
    fetch(
      `${getApiUrl()}${"/Account"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setProfessional(data);
        setTitle(data.title);
        setName(data.name);
        setRegistrationNo(data.registrationNo);
        setHospitalName(data.hospitalName);
        setDepartmentName(data.departmentName);
        setProfession(data.profession);
        
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onSubmit = () => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    setLoading(true);
    setSuccess("");
    setError("");
    let fd = {
    title: title,
    name : name,
    registrationNo: registrationNo,
    profession: profession,
    hospitalName: hospitalName,
    departmentName: departmentName
    };
    fetch(
      `${getApiUrl()}${"/Account/update"}`,
      {
        method: "post",
        body: JSON.stringify(fd),
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      }
    )
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            console.log(data);
            setProfessional(data);
            setTitle(data.title);
            setName(data.name);
            setRegistrationNo(data.registrationNo);
            setHospitalName(data.hospitalName);
            setProfession(data.profession);
            setDepartmentName(data.departmentName);
            ls.setProfessional({ title: data.title, name: data.name, profession: data.profession });
            setSuccess("Profile updated");
            setEdit(false);
          });
        }else if(response.status === 500){
          response.json().then(data => {
            setError(data.error || "An error occurred.");
          });
        }else {
          setError("An error occurred.");
        }
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  if (professional != null) {
    return (
      <div>
        <Box sx={paddingbox}>
          <Typography variant="h5" sx={dashboardText}>
            My Profile
          </Typography>
          <Box m={2} />
          <Grid container sx={mainGrid}>
            <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <Textfield title='Name' id='Name' required={false} disabled={!edit} value={name}
                  onChange={e => { setName(e.target.value); }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Textfield title='Professional Title' id='Professional_title' required={false} disabled={!edit}
                  value={title} maxCharacterLimit={50} onChange={e => { setTitle(e.target.value); }} />
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Textfield title='Registration Number (If applicable)' id='Professional_registration_number'
                  required={false} disabled={!edit} value={registrationNo} onChange={e => { setRegistrationNo(e.target.value); }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Textfield title='Profession' id='Profession' required={false} disabled={!edit} value={profession}
                  onChange={e => { setProfession(e.target.value); }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Textfield
                  title='Organization / Nursery / School / Hospital Name'
                  id='Name_of_the_Hospital_or_Organization'
                  required={false} disabled={!edit} value={hospitalName} onChange={e => { setHospitalName(e.target.value); }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Textfield title='Email' id='Email' required={false} disabled={true} value={professional.email} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Textfield title='Telephone' id='Phone_number' required={false} disabled={true} value={professional.phoneNumber} />
              </Grid>
            </Grid>
            <Box m={2} />
            <Grid item sm={12} container alignItems='center' justifyContent='flex-center'>
              {loading ? <CircularProgress size={30} /> : <Button variant="contained" sx={{ backgroundColor: rcolor, color: whitecolor }} onClick={handleEdit}>
                {edit ? "Save Changes" : "Edit Profile"}
              </Button>}
            </Grid>
            {success !== "" ?
                <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: "15px" }}>
                  <Typography style={{ color: "green" }}>{success}</Typography>
                </Box> : null}
            {error !== "" ?
                <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: "15px" }}>
                  <Typography style={{ color: "red" }}>{error}</Typography>
                </Box> : null}
          </Grid>
        </Box>
      </div>
    );
  } else {
    return null;
  }
}
export default MainDetails;
